import "./support.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import { useEffect, useState } from "react";
import ChatSidebar from "./chatSidebar";
import ChatArea from "./chatArea";
import { CircularProgress, Typography } from "@mui/material";

const Support = () => {
  const [selectedRequest, setSelectedRequest] = useState(null); 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
          <div className="app-container">
            <ChatSidebar setSelectedRequest={setSelectedRequest}/>
            <ChatArea selectedRequest={selectedRequest} />
          </div>
        </div>
    </div>
  );
};

export default Support;
